import React, { memo } from 'react';

/**
 * ProgressBar - Reusable progress bar component for ScoutIQ Dashboard
 * Simplified to ensure smooth CSS transitions
 */
function ProgressBar({ percent = 0, className = '', showPulse = false }) {
  const clampedPercent = Math.max(0, Math.min(100, percent));
  
  return (
    <div className="scoutiq-course-progress-bar">
      <div 
        className={`scoutiq-course-progress-fill ${className}${showPulse ? ' progress-pulse' : ''}`} 
        style={{ 
          width: `${clampedPercent}%`
        }} 
      />
    </div>
  );
}

// Memoize with strict comparison - only re-render if percent actually changes
export default memo(ProgressBar, (prevProps, nextProps) => {
  // Only re-render if percent changes - ignore className since it's stable
  return prevProps.percent === nextProps.percent;
});